var AppCommonModule = /** @class */ (function () {
    function AppCommonModule() {
    }
    return AppCommonModule;
}());
export { AppCommonModule };
